import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import RoomsAndStudents from '../RoomsAndStudents';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import StatisticReports from '../StatisticReports';


class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
   </React.Fragment>
  }
}

const StatisticReportsPage = () => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <StatisticReports />
  </Wrapper>
}

export default StatisticReportsPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/StatisticReports.js